const Card = ({ children, showContent = false, ...props }) => {
    return (
        <div className="curve-card" {...props}>
            {showContent && (
                <strong className="curve-card-content">
                    Get Covered Today Through Our Agents or Our Network of 200+ Partners
                </strong>
            )}
            {children}
        </div>
    );
};

export default Card;
